import { cn } from "@/lib/utils";

/**
 * DotPattern Component
 * 
 * Subtle dot grid pattern overlay for backgrounds.
 * Adds texture without overwhelming content.
 * Part of the LEAP design system's decorative elements.
 * 
 * @param className - Additional CSS classes
 * @param dotSize - Dot diameter in pixels (default: 2)
 * @param dotColor - Dot colour (default: "currentColor")
 * @param spacing - Grid spacing in pixels (default: 24)
 * 
 * @example
 * <DotPattern dotSize={2} spacing={24} />
 */
interface DotPatternProps {
  className?: string;
  dotSize?: number;
  dotColor?: string;
  spacing?: number;
}

export const DotPattern = ({ 
  className,
  dotSize = 2,
  dotColor = "currentColor",
  spacing = 24,
}: DotPatternProps) => {
  return (
    <div 
      className={cn("absolute inset-0 pointer-events-none opacity-[0.03]", className)}
      style={{
        backgroundImage: `radial-gradient(${dotColor} ${dotSize}px, transparent ${dotSize}px)`,
        backgroundSize: `${spacing}px ${spacing}px`,
      }}
    />
  );
};
